module.exports = {
          srcSet: __webpack_public_path__ + "e73593e2d8689f7c7855fe8c7f78aa9f-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "e73593e2d8689f7c7855fe8c7f78aa9f-180.png",width: 180,height: 180}],
          src: __webpack_public_path__ + "e73593e2d8689f7c7855fe8c7f78aa9f-180.png",
          toString:function(){return __webpack_public_path__ + "e73593e2d8689f7c7855fe8c7f78aa9f-180.png"},
          
          width: 180,
          height: 180
        }